export default __webpack_public_path__ + "static/media/icon_mynewsdesk.352b1ad6.webp";